"use client";

import { useState, useEffect } from "react";
import { useParams } from "next/navigation";
import { Segment } from "semantic-ui-react";
import { Title } from "../../../app/_shims/semantic-ui-react";
import { NeighborhoodsList } from "../../../common";
import { getcitydata } from "../../../modules/Graphql/cityquestionandanswergraphql";

const CityTopNeighborhoods = ({
  cityDetails,
  topNeighborhood: initialTopNeighborhood,
  isMobile,
  togglePrev: externalTogglePrev,
  activePage: externalActivePage,
  showList = false,
  isSSR = false,
}) => {
  if (!cityDetails?.[0] || !initialTopNeighborhood?.length) return null;

  const params = useParams();
  const formattedCitySlug = params?.id || "";

  const [topNeighborhood, setTopNeighborhood] = useState(
    initialTopNeighborhood,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [internalActivePage, setInternalActivePage] = useState(1);

  const isExternallyControlled =
    externalTogglePrev && externalActivePage !== undefined;

  const activePage = isExternallyControlled
    ? externalActivePage
    : internalActivePage;

  const togglePrev = isExternallyControlled
    ? externalTogglePrev
    : (e, { value }) => setInternalActivePage(value.activePage);

  useEffect(() => {
    if (!isSSR || hasFetched || !formattedCitySlug) return;

    const fetchTopNeighborhoods = async () => {
      if (!initialTopNeighborhood?.length) setIsLoading(true);
      try {
        const query = {
          start: 0,
          limit: 100,
          order: "DESC",
          orderBy: "npi",
          fields: [
            { name: "cityfullname", value: formattedCitySlug, operator: "=" },
          ],
        };
        const result = await getcitydata(query);
        const fetched = result?.data?.getcitydata ?? [];
        setTopNeighborhood(fetched);
      } catch (err) {
        console.error("Error fetching top neighborhoods:", err);
      } finally {
        setIsLoading(false);
        setHasFetched(true);
      }
    };

    fetchTopNeighborhoods();
  }, [isSSR, formattedCitySlug, hasFetched, initialTopNeighborhood]);

  useEffect(() => {
    if (!isSSR && initialTopNeighborhood?.length > 0) {
      setTopNeighborhood(initialTopNeighborhood);
    }
  }, [isSSR, initialTopNeighborhood]);

  const hasNeighborhoods = topNeighborhood?.length > 0;
  if (!hasNeighborhoods && !isLoading) return null;

  const firstNeighborhood = hasNeighborhoods ? topNeighborhood[0] : null;
  const labelSuffix = firstNeighborhood?.label?.split(",")?.pop()?.trim() || "";

  return (
    <>
      <Segment
        textAlign="left"
        basic
        style={{ padding: "13px 1em", margin: 0 }}
      >
        <div className="top_nh_title">
          <Title
            size="medium"
            className="top_nh_txt_right"
            as="h2"
            style={{
              float: "left",
              margin: "7px 0",
              letterSpacing: "0.3px",
            }}
          >
            Top Neighborhoods in{" "}
            <span style={{ float: "none", marginLeft: 3 }}>
              {isLoading ? (
                <span style={{ fontStyle: "italic", color: "#666" }}>
                  Loading...
                </span>
              ) : (
                <a
                  href={`/Nhranking/best-overall/${formattedCitySlug}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {firstNeighborhood?.census_name}
                  {labelSuffix ? `, ${labelSuffix}` : ""}
                </a>
              )}
            </span>
          </Title>
        </div>
      </Segment>

      {(isMobile || showList) && !isLoading && (
        <NeighborhoodsList
          id="neighborhoods"
          itemData={topNeighborhood}
          prev={togglePrev}
          active={activePage}
          href="/Neighborhood/"
          customclass="sim_nei_imgs"
          ispage="detailcity"
          isEnabled
          seeFullListLink={`/Nhranking/best-overall/${formattedCitySlug}`}
        />
      )}
    </>
  );
};
export default CityTopNeighborhoods;
